<template>
  <Dialog
    :title="chapterFormType === 'add' ? '添加章节' : '编辑章节'"
    :visible.sync="chapterDialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form
      label-width="120px"
      :model="chapterForm"
      :rules="chapterFormRules"
      ref="chapterFormRef"
    >
      <el-form-item label="章节名称：" prop="chapterName">
        <el-input
          maxlength="30"
          v-model.trim="chapterForm.chapterName"
          auto-complete="off"
          placeholder="请输入名称"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="章节排序：" prop="orderNum">
        <el-input-number
          :min="1"
          :max="100"
          :default="1"
          :step="1"
          :precision="0"
          v-model="chapterForm.orderNum"
        >
        </el-input-number>
      </el-form-item>
      <el-form-item width="100%">
        <el-button plain round size="small" @click="closeDialog"
          >关闭</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitChapterForm"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>
<script>
import { addChapter, updateChapter } from "@/api/course";
export default {
  name: "ChapterForm",
  data() {
    const validateChapterName = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const name = String(value).trim();
      const currentCode = this.chapterForm.chapterCode;
      const duplicated = (this.existingChapterList || []).some(item => {
        if (currentCode && item.chapterCode === currentCode) return false;
        return String(item.chapterName || "").trim() === name;
      });
      if (duplicated) {
        callback(new Error("该课程下章节名称不能重复"));
        return;
      }
      callback();
    };
    return {
      chapterFormType: "",
      chapterDialogVisible: false,
      existingChapterList: [],
      // 章节
      chapterForm: {
        orderNum: 1,
        chapterName: ""
      },
      chapterFormRules: {
        chapterName: [
          { required: true, message: "请输入章节名称", trigger: "blur" },
          { validator: validateChapterName, trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "请输入章节排序", trigger: "blur" }
        ]
      },
      submitLoading: false
    };
  },
  methods: {
    closeDialog() {
      this.$refs.chapterFormRef && this.$refs.chapterFormRef.resetFields();
      this.chapterForm = {
        orderNum: 1,
        chapterName: ""
      };
      this.existingChapterList = [];
      this.chapterDialogVisible = false;
    },

    async submitChapterForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.chapterFormRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        if (this.chapterFormType === "add") {
          await addChapter(this.chapterForm);
          this.$message.success("新增成功");
        } else {
          await updateChapter(this.chapterForm);
          this.$message.success("修改成功");
        }
        this.closeDialog();
        this.$emit("success");
      } finally {
        this.submitLoading = false;
      }
    },
    open(type, row = {}, existingList = []) {
      this.chapterFormType = type;
      this.existingChapterList = Array.isArray(existingList) ? existingList : [];
      if (type == "edit") {
        this.chapterForm = { ...row };
      } else {
        this.chapterForm = {
          orderNum: 1,
          chapterName: "",
          ...row
        };
      }
      this.chapterDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.chapterFormRef && this.$refs.chapterFormRef.clearValidate();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/CourseEdit/components/ChapterForm.vue